import { render, staticRenderFns } from "./pcHome.vue?vue&type=template&id=01483775&scoped=true&"
import script from "./pcHome.vue?vue&type=script&lang=js&"
export * from "./pcHome.vue?vue&type=script&lang=js&"
import style0 from "./pcHome.vue?vue&type=style&index=0&id=01483775&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01483775",
  null
  
)

export default component.exports